import { CreateOrGetQuizUsecase } from "@/arch/new_proposal/quizz/application/usecases/CreateOrGetQuizUsecase";
import { SendQuizAnswersUsecase } from "@/arch/new_proposal/quizz/application/usecases/SendQuizAnswersUsecase";
import { ContainerModule } from "inversify";
import { TYPES } from "@/arch/@core/main";

export const quizModule = new ContainerModule((bind) => {
  bind(TYPES.CreateOrGetQuizUsecase).to(CreateOrGetQuizUsecase);
  bind(TYPES.SendQuizAnswersUsecase).to(SendQuizAnswersUsecase);
});
